// extracted by mini-css-extract-plugin
module.exports = {"modalContent":"UpgradeEpcsModal_modalContent__wTo3B","modalForm":"UpgradeEpcsModal_modalForm__1MBf0","modalFooter":"UpgradeEpcsModal_modalFooter__3Wqll"};